module.exports = __webpack_public_path__ + "img/diplome-isosteo.825841a9.png";